import { useLenis } from "lenis/react";
import { Phone, MapPin, Instagram, Mail } from "lucide-react";
import { BRAND, NAV, NAV_MORE, LOCATIONS } from "../lib/site";

const SERVICES = ["Photo Frames", "Photo Printing", "Photo Gifts", "Wall Art", "Photo Albums", "Photo Restoration", "Photography", "Videography"];

export default function Footer() {
  const lenis = useLenis();
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) (lenis ? lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView({ behavior: "smooth" }));
  };

  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-pp-black noise text-white">
      <div className="mx-auto max-w-[1500px] px-5 py-20 md:px-10 md:py-28">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="inline-block bg-white p-4">
              <img src={BRAND.logo} alt="PHOTO PIXEL®" className="h-10 w-auto md:h-12" />
            </div>
            <h2 className="mt-10 font-display text-6xl font-black leading-[0.85] tracking-tight md:text-7xl">
              MEMORIES<br />WORTH<br /><span className="text-pp-red">FRAMING.</span>
            </h2>
            <div className="mt-8 flex gap-3">
              <a href={BRAND.social.productInsta} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex h-11 w-11 items-center justify-center border border-white/20 transition-colors hover:border-pp-red hover:bg-pp-red" title="@photopixel.co.in — Prints • Frames • Gifts">
                <Instagram size={18} />
              </a>
              <a href={BRAND.social.storiesInsta} target="_blank" rel="noreferrer" data-testid="footer-instagram-stories" className="flex h-11 items-center justify-center gap-2 border border-white/20 px-3 text-xs transition-colors hover:border-pp-red hover:bg-pp-red" title="@photopixel_stories — Photography">
                <Instagram size={16} /> Stories
              </a>
            </div>
          </div>

          <div className="md:col-span-2 md:col-start-7">
            <p className="overline text-pp-red">Explore</p>
            <ul className="mt-6 space-y-3">
              {[...NAV, ...NAV_MORE, { label: "Contact", id: "contact" }].map((n) => (
                <li key={n.id}>
                  <button onClick={() => go(n.id)} data-testid={`footer-link-${n.id}`} className="text-white/60 transition-colors hover:text-white">
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-pp-red">Services</p>
            <ul className="mt-6 space-y-3 text-white/60">
              {SERVICES.map((s) => <li key={s}>{s}</li>)}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-pp-red">Locations</p>
            <ul className="mt-6 space-y-6">
              {LOCATIONS.map((l) => (
                <li key={l.id}>
                  <p className="text-sm font-semibold text-white">{l.name}</p>
                  {l.comingSoon ? (
                    <p className="mt-1 text-sm text-pp-red">Coming Soon 🚀</p>
                  ) : (
                    <>
                      <a href={`tel:${l.tel}`} className="mt-1 flex items-center gap-2 text-sm text-white/60 transition-colors hover:text-pp-red">
                        <Phone size={13} /> {l.phone}
                      </a>
                      <a href={`mailto:${l.email}`} className="mt-1 flex items-center gap-2 text-sm text-white/60 transition-colors hover:text-pp-red">
                        <Mail size={13} /> {l.email}
                      </a>
                      <a href={l.maps} target="_blank" rel="noreferrer" className="mt-1 flex items-center gap-2 text-sm text-white/60 transition-colors hover:text-pp-red">
                        <MapPin size={13} /> Directions
                      </a>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} PHOTO PIXEL®. All Rights Reserved.</p>
          <p className="overline">Founder — {BRAND.founder.name}</p>
        </div>
      </div>
    </footer>
  );
}
